import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Input, Nav, NavItem, NavLink } from "reactstrap";
import "./return-order.scss";
import { SetStateAction, useEffect, useState } from "react";
// import ConfirmOrderModal from "./components/ConfirmOrderModal";
// import OrderHistoryCard from "./components/OrderHistoryCard";
import classnames from "classnames";
import axios from "axios";
// import TrackOrder from "./components/TrackOrder";
// import TrackOrderMOdal from "./components/TrackOrder";
import { toast, ToastContainer } from "react-toastify";
import OrderHistoryCard from "../components/OrderHistoryCard";
import ReturnOrderCard from "../components/ReturnOrderCard";
import filterIcon from "../../../../assets/images/filter-icon.png";
import Papa from "papaparse";

const ReturnOrder = (props: any) => {
  document.title = "Return Order | BuyPass";
  const [counts, setCounts] = useState<any>();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermTwo, setSearchTermTwo] = useState("");
  const [searchTermCustomerPhone, setSearchTermCustomerPhone] = useState("");
  const [orders, setOrders] = useState<any>();
  const [activeTab, setActiveTab] = useState("all");
  var [statusTab, setStatusTab] = useState("all");
  const [showFilters, setShowFilters] = useState(false);
  const [exportingData, setExportingData] = useState<any>([]);

  const tabs = [
    {
      label: "Today",
      type: "today",
      filterType: "today",
      active: true,
    },
    {
      label: "Yesterday",
      type: "yesterday",
      filterType: "yesterday",
      active: false,
    },
    {
      label: "Last 7 Days",
      type: "lastSevenDays",
      filterType: "lastSevenDays",
      active: false,
    },
    {
      label: "Last 30 Days",
      type: "lastThirtyDays",
      filterType: "lastThirtyDays",
      active: false,
    },
  ];

  const headerNavigations = [
    {
      label: "All Orders",
      value: "all",
      active: true,
      count: counts?.allCount,
    },
    {
      label: "Return Initiated",
      value: "returnInitiated",
      active: false,
      count: counts?.pendingCount,
    },
    {
      label: "QC in Progress",
      value: "qCInProgress",
      active: false,
      count: counts?.acceptedCount,
    },
    {
      label: "Return in Progress",
      value: "returnInProgress",
      active: false,
      count: counts?.rejectedCount,
    },
    {
      label: "Return to Seller",
      value: "returnToSeller",
      active: false,
      count: counts?.deliveredCount,
    },
    {
      label: "Cancel",
      value: "cancel",
      active: false,
      count: counts?.cancelledCount,
    },
  ];
  const [ConfirmModal, setConfirmModal] = useState(false);
  const [proofModal, setProofModal] = useState(false);
  const [navigations, setNavigations] = useState(headerNavigations[0]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);
  const [activeDayTab, setActiveDayTab] = useState("Today");

   useEffect(() => {
        const handler = setTimeout(() => {
          onGetOrders(currentPage,"");
        }, 500);
    
        return () => {
          clearTimeout(handler);
        };
        // eslint-disable-next-line
      }, [searchTerm, currentPage]);

  const onGetOrders = async (page: number, filterType: string) => {
    try {
      const response = await axios.get(
        `api/v1/order/return?page=${page}&count=${itemsPerPage}&status=${activeTab}&keyword=${searchTerm}&filter-type=${filterType}`
      );
      if (response?.data) {
        setOrders(response.data.data);
        setCounts(response.data.counts);
        setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
      }
    } catch (err: any) {
    } finally {
    }
  };
  const onGetOrdersCustomerPhone = async (page: number, filterType: string) => {
    try {
      const response = await axios.get(
        `api/v1/order/return?page=${page}&count=${itemsPerPage}&status=${activeTab}&keyword=${searchTermCustomerPhone}&filter-type=${filterType}`
      );
      if (response?.data) {
        setOrders(response.data.data);
        setCounts(response.data.counts);
        setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
      }
    } catch (err: any) {
    } finally {
    }
  };
   const handleItemsPerPageChange = (e:any) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to page 1 when count changes
  };
  const onGetOrdersSearch = async (page: number, filterType: string) => {
    try {
      const response = await axios.get(
        `api/v1/order/return?page=${page}&count=${itemsPerPage}&status=${activeTab}&keyword=${searchTermTwo}&filter-type=${filterType}`
      );
      if (response?.data) {
        setOrders(response.data.data);
        setCounts(response.data.counts);
        setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
      }
    } catch (err: any) {
    } finally {
    }
  };

  const toggleFilters = () => {
    setShowFilters((prev) => !prev);
  };

  const onGetOrdersWithStatus = async (page: number, status: any) => {
    try {
      setStatusTab(status);
      console.log(statusTab);
      const response = await axios.get(
        `api/v1/order/return?page=${page}&count=${itemsPerPage}&status=${status}&keyword=${searchTerm}`
      );
      if (response?.data) {
        setOrders(response.data.data);
        setCounts(response.data.counts);
        setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
      }
    } catch (err: any) {
    } finally {
    }
  };

  useEffect(() => {
    onGetOrders(currentPage, "");
  }, [ currentPage, itemsPerPage]);

  useEffect(() => {
    onGetOrdersCustomerPhone(currentPage, "");
  }, [searchTermCustomerPhone, currentPage]);

  useEffect(() => {
    onGetOrdersSearch(currentPage, "");
  }, [searchTermTwo, currentPage]);

  const handleTabClick = (type: string, filterType: string) => {
    setActiveTab(type);
    onGetOrders(1, filterType);
  };

   const handleDownloadAllCsv = () => {
    if (!exportingData || exportingData.length === 0) {
      toast.error("No data available for download!");
      return;
    }

    const jsonData = exportingData.map((item: any) => ({
      orderId: item?.orderId || "-",
      productName: item?.returnItem?.productName || "--",
      sku: item?.returnItem?.sku || "--",
      category: item?.returnItem?.category || "--",
      price: item?.returnItem?.price || "0",
      quantity: item?.returnItem?.quantity || "0",
      status: item?.status || "-",
      returnMessage: item?.returnMessage || "-",
      customerName: item?.pickupDetails?.name || "--",
      customerPhone: item?.pickupDetails?.phoneNumber || "--",
    }));
    const csv = Papa.unparse(jsonData, {
      delimiter: ",",
      header: true,
    });

    const blob = new Blob(["\ufeff" + csv], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "return_orders.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

    const handlePageChange = (page: number) => {
      setCurrentPage(page);
    };

  return (
    <div className="page-content returnordersMainPage page-content-mobile">
      <ToastContainer />
      <Container fluid>
        <BreadCrumb
          title="Manage Return Orders"
          pageTitle="Orders"
          pageTitleRoute="/manage-order"
        />

        {/* <ConfirmOrderModal
          show={ConfirmModal}
          onCloseClick={() => setConfirmModal(false)}
        /> */}

        <Card>
          <div className="navigatiovCardDv">
            <div className="helo">
              <>
                {counts && (
                  <Nav
                    className="nav-tabs nav-tabs-custom nav-success"
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "all" })}
                        href="#"
                        onClick={() => {
                          setCurrentPage(1);
                          onGetOrdersWithStatus(currentPage, "all");
                          setActiveTab("all");
                        }}
                        data-testing-id="all_orders"
                      >
                        All
                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                          {counts.allCount}
                        </span>
                      </NavLink>
                    </NavItem>
                    {/*<NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "returnInitiated",
                        })}
                        href="#"
                        data-testing-id="newOrderTabar_orders"
                        onClick={() => {
                          setCurrentPage(1);
                          onGetOrdersWithStatus(currentPage, "returnInitiated");
                          setActiveTab("returnInitiated");
                        }}
                      >
                        Return Initiated
                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                          {counts.returnInitiatedCount}
                        </span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "qcInProgress",
                        })}
                        href="#"
                        data-testing-id="pendingTabbar_orders"
                        onClick={() => {
                          setCurrentPage(1);
                          onGetOrdersWithStatus(currentPage, "qcInProgress");
                          setActiveTab("qcInProgress");
                        }}
                      >
                        QC in Progress
                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                          {counts.qcInProgressCount}
                        </span>
                      </NavLink>
                    </NavItem> */}
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "returnInProgress",
                        })}
                        href="#"
                        data-testing-id="ReturninProgress_orders"
                        onClick={() => {
                          setCurrentPage(1);
                          onGetOrdersWithStatus(
                            currentPage,
                            "returnInProgress"
                          );
                          setActiveTab("returnInProgress");
                        }}
                      >
                        Return in Progress
                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                          {counts.returnInProgressCount}
                        </span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "returnToSeller",
                        })}
                        href="#"
                        data-testing-id="ReturnedtoSeller"
                        onClick={() => {
                          setCurrentPage(1);
                          onGetOrdersWithStatus(currentPage, "returnToSeller");
                          setActiveTab("returnToSeller");
                        }}
                      >
                        Returned to Seller
                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                          {counts.returnToSellerCount}
                        </span>
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "cancelled",
                        })}
                        href="#"
                        data-testing-id="acceptedTabbar_orders"
                        onClick={() => {
                          setCurrentPage(1);
                          onGetOrdersWithStatus(currentPage, "cancelled");
                          setActiveTab("cancelled");
                        }}
                      >
                        Cancel
                        <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                          {counts.cancel}
                        </span>
                      </NavLink>
                    </NavItem> */}
                  </Nav>
                )}
                <div className="mobile-hide">
                  <button
                    className="csv"
                    data-testing-id="exportCsv_returnOrder"
                    onClick={() => handleDownloadAllCsv()}
                  >
                    Expot CSV
                  </button>
                </div>
              </>
            </div>

            <div className="serchNavigationDv">
              <div className="servhButtonDv">
                <div className="serchDv">
                <i className="bx bx-search"></i>
                <input
                  type="text"
                  placeholder="Search"
                  data-testing-id="serachInput_order"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
                 <button
                    className="csv mobile-show"
                    data-testing-id="exportCsv_returnOrder"
                    onClick={() => handleDownloadAllCsv()}
                  >
                    Expot CSV
                  </button>
              </div>
              
              {/* <p style={{ fontSize: "14px", margin: "0px", fontWeight: "400", color: "#21262C" }}>Total 10 items</p> */}
              <div className="paginationDv">
                <nav aria-label="Page navigation example">
                  <ul className="pagination detailPagepagi m-0">
                     <select value={itemsPerPage} style={{margin:'5px'}} onChange={handleItemsPerPageChange}>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={80}>80</option>
          <option value={100}>100</option>
        </select>
                    {/* Previous Arrow */}
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        style={{
                          height: "26px",
                          display: "flex",
                          alignItems: "center",
                          border: "none",
                        }}
                        className="page-link"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                      >
                        <i
                          style={{ height: "11px" }}
                          className="bx bxs-left-arrow"
                        ></i>
                      </button>
                    </li>

                   {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
  let startPage = 1;

  if (totalPages <= 5) {
    startPage = 1;
  } else if (currentPage <= 3) {
    startPage = 1;
  } else if (currentPage >= totalPages - 2) {
    startPage = totalPages - 4;
  } else {
    startPage = currentPage - 2;
  }

  return startPage + i;
                    }).map((page) => (
                      <div>
                        <li
                          className={`page-item ${
                            currentPage === page ? "active" : ""
                          }`}
                          key={page}
                        >
                          <button
                            style={{ height: "26px" }}
                            className="page-link orderPg"
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        </li>
                      </div>
                    ))}

                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link orderPg"
                        style={{
                          height: "26px",
                          display: "flex",
                          alignItems: "center",
                          border: "none",
                        }}
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                      >
                        <i
                          className="bx bxs-right-arrow"
                          style={{ width: "6px", height: "11px" }}
                        ></i>
                      </button>
                    </li>
                    <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    style={{
      margin: "0 10px",
      padding: "2px 6px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      fontSize: "13px",
    }}
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
      <option key={pageNum} value={pageNum}>
        Page {pageNum}
      </option>
    ))}
  </select>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="tableHead mobile-hide">
              <div className="tableHeadChild firstChild">
                <h4>Product</h4>
              </div>
              <div className="contenDv">
                <div className="tableHeadChild">
                  <h4>Total Amount</h4>
                </div>
                <div className="tableHeadChild secondinfoDv">
                  <h4>Order Status</h4>
                </div>
                <div className="tableHeadChild thirdinfoDv">
                  <h4>Actions</h4>
                </div>
              </div>
              <div
                className="tableHeadChild lastChild"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "baseline",
                  cursor: "pointer",
                }}
                onClick={toggleFilters}
                data-testing-id="filter_Returnorder"
              >
                <img
                  src={filterIcon}
                  style={{ width: "13px", height: "13px", marginRight: "5px" }}
                  alt=""
                />
                <h4 className="text-secondary">Filter</h4>
              </div>
            </div>
            {showFilters && (
              <>
                <div className="chipTodayContainer">
                  {tabs.map((item: any, index) => (
                    <div
                      key={index}
                      className={`chipDv ${
                        activeTab === item.type ? "active" : ""
                      }`}
                      onClick={() => handleTabClick(item.type, item.filterType)}
                      data-testing-id={"weeklyTab_Order" + index}
                    >
                      <p className="m-0">{item.label}</p>
                    </div>
                  ))}
                </div>
                <div className="inputContainer">
                  <div className="searchWrapper">
                    <input
                      type="text"
                      placeholder="Search"
                      data-testing-id="serachInput_ReturnOrder"
                      value={searchTermTwo}
                      onChange={(e) => setSearchTermTwo(e.target.value)}
                    />
                    <i className="bx bx-search searchIcon"></i>
                  </div>
                  <div className="searchWrapper">
                    <input
  type="text"
  placeholder="Phone Number"
  data-testing-id="customerPhoneNumberInput_ReturnOrder"
  value={searchTermCustomerPhone}
  onChange={(e) => {
    let value = e.target.value;

    // If value starts with '0', replace it with '92'
    if (value.startsWith("0")) {
      value = "92" + value.slice(1);
    }

    setSearchTermCustomerPhone(value);
  }}
/>
                    <i className="bx bx-search searchIcon"></i>
                  </div>
                  <div className="searchWrapper">
                    <select
                      className="dropdown"
                      onChange={(e) =>
                        onGetOrdersWithStatus(currentPage, e.target.value)
                      }
                    >
                      <option value="all">All</option>
                      {/* <option value="returnInitiated">Return Initiated</option> */}
                      {/* <option value="qcInProgress">QC in Progress</option> */}
                      <option value="returnInProgress">
                        Return in Progress
                      </option>
                      <option value="returnToSeller">Returned to Seller</option>
                      {/* <option value="cancelled">Cancelled</option> */}
                    </select>
                  </div>
                </div>
              </>
            )}
          </div>
        </Card>
        <div className="cardMarRes">
          {navigations.label === "All Orders" && (
          <>
            {orders && orders.length > 0 ? (
              orders.map((order: any, index: any) => (
                <ReturnOrderCard
                  key={order._id}
                  order={order}
                  index={index}
                  activeTab={activeTab}
                  setOrders={setOrders}
                  setTotalPages={setTotalPages}
                  exportingData={exportingData}
                  setExportingData={setExportingData}
                />
              ))
            ) : (
              <h2>No Data Found!</h2>
            )}
          </>
        )}
        </div>
      </Container>
    </div>
  );
};

export default ReturnOrder;
